module.exports = __webpack_public_path__ + "static/media/Mastercard.2e3d2eae.svg";